/**
 * Enlaces a la aplicación.
 *
 * La web pública y la app comparten dominio: nginx sirve esta landing estática
 * en el ápice y deja pasar a la app Nuxt las rutas de autenticación, alta y
 * panel (ver deploy/nginx/reservaya.local.conf en el repo reserva-ya). Por eso
 * son rutas relativas y no URLs absolutas: funcionan igual en local
 * (peluqueria.localhost) que en producción.
 */

/** Acceso de usuarios ya registrados. */
export const LOGIN_URL = '/login';

/**
 * Alta de negocio. El wizard vive dentro de /login y se abre con `?form=register`;
 * el parámetro se conserva en la URL para que una recarga a media alta vuelva al
 * mismo paso (ver pages/login.vue y useWizardResume en reserva-ya).
 */
export const REGISTER_URL = '/login?form=register';
